import { Heading, Stack, Text } from "@chakra-ui/react";
import NextImage from "next/image";
import * as React from "react";

import { Offer } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";
import CustomLink from "components/Chakra/CustomLink";
import Price from "components/Price";
import { formatLocalitySearch } from "utils/offer";

type IProps = {
  offer: Pick<
    Offer,
    | "seo"
    | "id"
    | "photos"
    | "street"
    | "village"
    | "title"
    | "villagePart"
    | "rentalPrice"
  >;
  dataTest?: string;
};

const OfferCard: React.FC<IProps> = ({ offer, dataTest }) => (
  <CustomLink
    to="/inzerat/[seo]/[id]"
    display="block"
    routeProps={{ seo: offer.seo, id: offer.id.toString() }}
    trackEventPayload={{
      "dl.eCat": "homepage",
      "dl.eAct": "offer.clicked",
      "dl.eLab": "Zobrazit inzerát",
    }}
    prefetch={false}
  >
    <Stack w={["286px", "218px"]} h="100%" data-test={dataTest}>
      <Stack h={["215px", "164px"]} position="relative">
        <NextImage
          priority
          fill
          src={offer.photos[0]?.path ?? "/fe/img/common/inzerat_bez_fotky.jpg"}
          alt={`foto-${offer.photos[0]?.id}`}
          style={{
            borderRadius: "6px",
            objectFit: "cover",
            objectPosition: "relative",
          }}
          data-test={`${dataTest}.image`}
        />
      </Stack>
      <Stack
        spacing="8px"
        justify="space-between"
        minW={["unset", "164px"]}
        flex="1"
      >
        <Stack spacing="4px">
          <Text pb="3px" variant="small_2" data-test={`${dataTest}.locality`}>
            {formatLocalitySearch({
              street: offer.street ?? null,
              village: offer.village ?? null,
              villagePart: offer.villagePart ?? null,
            })}
          </Text>
          <Heading
            as="h3"
            variant="h3_1"
            color="ud-primary"
            data-test={`${dataTest}.disposition`}
          >
            {offer.title}
          </Heading>
        </Stack>
        <Stack>
          {offer.rentalPrice && offer.rentalPrice.value > 1 ? (
            <Heading
              as="h4"
              variant="h3_1"
              color="ud-grey-600"
              data-test={`${dataTest}.price`}
            >
              <Price value={offer.rentalPrice.value} />
            </Heading>
          ) : (
            <Text
              fontWeight="bold"
              fontSize="18px"
              data-test={`${dataTest}.price`}
            >
              Info o ceně na dotaz
            </Text>
          )}
        </Stack>
      </Stack>
    </Stack>
  </CustomLink>
);

export default OfferCard;
